import Color from "color"
import { PINNED_Z_INDEX, pinnedCellSx } from "lib/@components/managed-columns/pinned-cell-styles"
import { ACTION_COLUMN_WIDTH } from "routes/asset-register/plugins/regime-display/asset-view-table/asset-view-column-definitions.mjs"

export function actionColumnBg(theme) {
    return Color(theme.palette.background.default).darken(0.02).hex()
}

export function bodyCellPinnedStyle(isPinned, theme) {
    if (!isPinned) return {}
    return pinnedCellSx(PINNED_Z_INDEX.body, theme, { bgcolor: actionColumnBg(theme) })
}

export function actionCellPinnedStyle(isPinned, theme) {
    if (!isPinned) return {}
    return pinnedCellSx(PINNED_Z_INDEX.actionRow, theme, { bgcolor: actionColumnBg(theme) })
}

export function stickyActionCellSx(theme) {
    return {
        position: "sticky",
        right: 0,
        zIndex: PINNED_Z_INDEX.actionColumn,
        width: ACTION_COLUMN_WIDTH,
        minWidth: ACTION_COLUMN_WIDTH,
        maxWidth: ACTION_COLUMN_WIDTH,
        bgcolor: actionColumnBg(theme),
        boxShadow: `1px 0px 0px 0px ${theme.palette.divider} inset`,
    }
}
